<template>
  <v-sheet>
    <v-form
      class="cmd-form"
      ref="form"
      @submit.prevent="sendOTP"
      lazy-validation
    >
      <v-container>
        <v-row justify="space-between">
          <v-col cols="12" sm="11" class="pt-0 pr-sm-8">
            <h1 class="mb-5">{{ $t('identity.title') }}</h1>
          </v-col>
          <v-col cols="12" sm="6" class="pt-0 form-field">
            <IdentityCard :idtName="idtName" :idtIdentifier="idtIdentifier">
              <template #image>
                <IconCMD_PT :height="36" />
              </template>
            </IdentityCard>
            <p class="error-fields" v-if="errorMsg['mobileNumber']">
              {{ $t('errors.' + errorMsg['mobileNumber']) }}
            </p>
          </v-col>
        </v-row>
      </v-container>
      <v-container>
        <v-row justify="space-between">
          <v-col cols="12" sm="10" class="pt-0 pr-6">
            <p class="mb-6">{{ $t('authentication.textStored') }}</p>
          </v-col>
          <v-col cols="12" sm="6" class="pt-0 form-field">
            <label class="label-form mb-2">{{
              $t('authentication.codeLabel[0]')
            }}</label>
            <v-text-field
              class="password-input"
              :placeholder="$t('authentication.codeLabel[1]')"
              v-model="otpCode"
              :class="{ 'error-fields': errorMsg['otpCode'] }"
              flat
              solo
              inputmode="numeric"
              type="password"
              hide-details
              @input="clearError('otpCode')"
            ></v-text-field>
            <p class="error-fields" v-if="errorMsg['otpCode']">
              {{ $t('errors.' + errorMsg['otpCode']) }}
            </p>
          </v-col>
        </v-row>
      </v-container>
      <v-footer fixed class="iframe-footer">
        <v-container grid-list-md text-center>
          <v-layout justify-end>
            <v-btn id="back" @click="back" class="back button-iframe">{{
              $t('button.back')
            }}</v-btn>
            <v-btn
              id="advance-btn"
              :loading="isLoading"
              :disabled="isDisabled"
              depressed
              type="submit"
              class="advance button-iframe"
              >{{ buttonText }}</v-btn
            >
          </v-layout>
        </v-container>
      </v-footer>
    </v-form>
  </v-sheet>
</template>

<script>
import IdentityCard from '@/components/Identity/Card';
import mixinQES from './mixinQES';
import IconCMD_PT from '@/assets/icons/icon-cc-pt';
// import { mapGetters } from 'vuex';

import {
  SEND_CMD_CREDENTIALS,
  VALIDATE_OPT,
} from '../../stores/modules/consts';

export default {
  name: 'SignatureProcess',
  mixins: [mixinQES],
  components: {
    IdentityCard,
    IconCMD_PT,
  },
  watch: {
    mobileNumber(newValue) {
      if (newValue && newValue.length >= 9) {
        // console.log('wather: ', newValue);
        // delete this.errorMsg['mobileNumber'];
        this.$forceUpdate();
      }
    },
    otpCode(newValue) {
      if (newValue && newValue.length >= 6) {
        delete this.errorMsg['otpCode'];
        // this.errorMsg = null;
      }
    },
  },
  methods: {
    clearError(error) {
      if (this.errorMsg[error]) {
        delete this.errorMsg[error];
      }
      delete this.errorMsg['expired'];
      // this.errorMsg = errorType;
      this.hasErrors = !this.errorMsg; // Object.keys(this.errorMsg).length != 0;
    },

    back() {
      console.log('Back Step');
      this.hasErrors = false;
      this.errorMsg = {};
      this.$router.push({ name: this.BASE_ROUTE });
      this.$store.commit('errorMsg');
    },

    async sendOTP() {
      console.log('sendOTP');
      this.isLoading = true;

      if (!this.otpCode || this.otpCode.length < 6) {
        this.errorMsg['otpCode'] = 'codeRequired';
        this.isLoading = false;
        return;
      }

      let res = await this.$store
        .dispatch(VALIDATE_OPT, {
          otpCode: this.otpCode,
          isEncrypted: true,
        })
        .catch((errorMsg) => {
          console.log(errorMsg);

          const {
            event,
            event_category,
            event_label,
            type,
            message,
          } = errorMsg;

          if (type == 'banner') {
            this.$store.commit('errorMsg', message);
          } else {
            this.errorMsg[type] = message;
          }

          this.$gtag.event(event, {
            event_category,
            event_label,
          });

          this.$forceUpdate();
        });
      console.log(res);
      if (res) {
        this.$router.push(this.ROUTE_SUCCESS);
      }

      this.isLoading = false;
    },
    async sendPinAndNumber() {
      // Check fields
      let res = await this.$store
        .dispatch(SEND_CMD_CREDENTIALS, {
          pin: this.pinEncrypted,
          number: this.mobileNumberEncrypted,
          isEncrypted: true,
        })
        .catch((errorMsg) => {
          console.log(errorMsg);

          const {
            event,
            event_category,
            event_label,
            message,
            type,
          } = errorMsg;

          if (type == 'banner') {
            this.$store.commit('errorMsg', message);
          } else {
            this.errorMsg[type] = message;
          }

          this.$gtag.event(event, {
            event_category,
            event_label,
          });
          this.$forceUpdate();
        });

      this.isLoading = false;

      console.log(res);
    },
  },
  mounted() {
    this.isLoading = true;

    this.mobileNumber = this.$store.state.qes.mobileNumber;
    this.mobileNumberEncrypted = this.$store.state.qes.mobileNumberEncrypted;
    this.pinEncrypted = this.$store.state.qes.pinEncrypted;

    this.sendPinAndNumber();
  },
  computed: {
    isDisabled() {
      return this.hasErrors; //Object.keys(this.errorMsg).length > 0;
    },
    buttonText() {
      return this.$t('button.sign');
    },
    idtName() {
      // console.log(this.$t(`idtName.${this.idt}`));
      return this.$t(`idtName.${this.idt}`);
    },
    idtIdentifier() {
      return `${this.$t(`idtIdentifier.${this.idt}`, {
        mobileNumber: this.mobileNumber,
      })}`;
    },
  },
  data() {
    return {
      mobileNumber: null,
      mobileNumberEncrypted: null,
      pinEncrypted: null,
      otpCode: null,
      errorMsg: {},
      hasErrors: false,
      isLoading: false,
      idt: 'UC_CMD_PT',
    };
  },
};
</script>
<style lang="scss">
.mobile-dropdown {
  &.vue-tel-input {
    border: solid 1px var(--light-grey);
    &--has-focus {
      border: solid 1px var(--teal-blue);
    }
    input,
    input::placeholder {
      margin: 5px 0;
      padding: 2px 0;
      font-size: 14px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 2;
      letter-spacing: normal;
      color: var(--charcoal-grey);
    }
  }
}
</style>
